module.exports = __webpack_public_path__ + "static/media/Sales_file_template.280dfa9d.csv";